"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../../../hooks");
var _CetComponentsProvider = require("../../../../providers/CetComponentsProvider");
const useStyles = props => {
  const {
    isDisabled,
    isSelected,
    color = 'basic',
    size = 'medium',
    isSeparator = false
  } = props;
  const {
    themeColors
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    pxToRem,
    fontSizeProps
  } = (0, _hooks.useStylesUtils)();
  const ccListItemStyle = (0, _react.useMemo)(() => {
    const colorProps = () => {
      const borderColor = color === 'primary' ? themeColors?.general.border : 'transparent';
      const marginBlockStart = color === 'primary' ? pxToRem(12) : pxToRem(2);
      const padding = color === 'primary' ? `${pxToRem(8)} ${pxToRem(12)}` : `${pxToRem(4)} ${pxToRem(12)}`;
      return {
        borderColor,
        marginBlockStart,
        padding
      };
    };
    const hoverOrSelectedColorProps = () => {
      const background = color === 'primary' ? themeColors?.primary.light : themeColors?.basic.main;
      const borderColor = color === 'primary' ? themeColors?.primary.main : 'transparent';
      const textColor = color === 'primary' ? themeColors?.primary.main : themeColors?.general.text;
      return {
        background,
        borderColor,
        color: textColor
      };
    };
    const hoverColorProps = () => {
      if (isDisabled || isSeparator) {
        return {};
      }
      return {
        ...hoverOrSelectedColorProps()
      };
    };
    const selectedColorProps = () => {
      if (isSelected) {
        return {
          ...hoverOrSelectedColorProps()
        };
      }
      return {};
    };
    const disabledProps = () => {
      if (isDisabled) {
        return {
          opacity: '.5',
          cursor: 'default'
        };
      }
      return {};
    };
    const separatorProps = () => {
      if (isSeparator) {
        return {
          pointerEvents: 'none',
          cursor: 'inherit',
          color: themeColors?.primary.main,
          whiteSpace: 'nowrap',
          gap: pxToRem(8),
          paddingInline: pxToRem(4),
          '&:after': {
            content: "''",
            height: pxToRem(2),
            width: '100%',
            backgroundColor: themeColors?.general.border
          }
        };
      }
      return {};
    };
    const ccListItem = (0, _css.css)({
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      borderRadius: pxToRem(5),
      cursor: 'pointer',
      border: '1px solid transparent',
      color: themeColors?.general.text,
      ...fontSizeProps(size),
      ...colorProps(),
      ...selectedColorProps(),
      ...disabledProps(),
      ...separatorProps(),
      '&:hover': {
        ...hoverColorProps()
      },
      '&:first-child': {
        marginBlockStart: 0
      }
    });
    return ccListItem;
  }, [pxToRem, themeColors?.general.text, themeColors?.general.border, themeColors?.primary.light, themeColors?.primary.main, themeColors?.basic.main, fontSizeProps, size, color, isDisabled, isSeparator, isSelected]);
  return {
    'cc-ListItem': ccListItemStyle
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;